export default __webpack_public_path__ + "static/revenue-cat-package-illustration-3691f8d69c4e3c013c39bf4189723a03.svg";